import { get } from 'lodash';

import objects from '../recorders/objects'; // GTM Object Schemas

import CARRIERS from '../../constants/operating-carriers';
import FARES from '../../constants/fare-types';
import REGIONS from '../../constants/region-type';
import safeLocalStorage from '../../utilities/safe-local-storage';

const ULR_PATH = window.location.pathname;

function baggageImpression({ currencyCode, flightItineraryType, globalMarketFlight, options, legCode, legCollection }) {
  const products = [];
  const route = objects.ecommerce.product.getRoute(legCode, legCollection);
  const fareFamily = objects.ecommerce.product.getFare(legCode, legCollection);
  const isRoundTrip = flightItineraryType && flightItineraryType === 'ROUNDTRIP';
  const flightType = isRoundTrip ? 'RT' : flightItineraryType === 'ONEWAY' ? 'OW' : 'MC';
  const marketingFlight = objects.ecommerce.product.getMarketingFlight({ flightType, isRoundTrip, legCode, legCollection });
  const internationalFlight = globalMarketFlight && globalMarketFlight !== 'DOMESTIC';

  options.forEach((item, index) => {
    if (item.type) {
      products.push(objects.ecommerce.product.buildProductSchema({
        name: item.commercialName,
        id: item.type,
        price: item.price,
        brand: 'Aeromexico',
        category: `Baggage/Ancillary/${ route }/${ FARES.FARE_FAMILIES_NAMES[fareFamily] }/${ marketingFlight }`,
        position: !internationalFlight ? index : index + 1,
        baggageCheckedBag: item?.commercialName.includes('Carry-on') ? 'NA' : item.commercialName,
        baggageCarryonBag: item?.commercialName.includes('Carry-on') ? item.commercialName : 'NA',
      }));
    }
  });

  return objects.manage.baggageImpression({ currencyCode, products });
}

function tierBenefitRedemption(options) {
  return objects.manage.tierBenefitRedemption(options);
}

function getDepartureAirportByLeg(allSegments) {
  return allSegments[0].departureAirport;
}

function getArrivalAirportByLeg(allSegments) {
  return allSegments[(allSegments.length - 1)].arrivalAirport;
}

function checkout({ modifiedPNRModel, ancillaryBuilderInstance, pnrModel }) {
  [modifiedPNRModel.products, modifiedPNRModel.productsCP, modifiedPNRModel.CPflights] = _getProducts(modifiedPNRModel, ancillaryBuilderInstance);
  if (modifiedPNRModel?.products?.some(ancillary => ancillary?.name === 'Vuela Verde')) {
    const ancillary = ancillaryBuilderInstance?.ancillariesModel['09T'];
    const segment = [];
    // eslint-disable-next-line no-unused-expressions
    pnrModel?.legCollection?.map(leg => {
      if (leg?.segmentsCollection?.length > 1) {
        segment.push(getDepartureAirportByLeg(leg?.segmentsCollection) + '-' + getArrivalAirportByLeg(leg?.segmentsCollection));
      } else {
        segment.push(leg?.segmentsCollection?.map(segment => segment?.departureAirport + '-' + segment?.arrivalAirport)[0]);
      }
    });
    const pax = pnrModel?.cart?.travelerCollection?.length;
    let index = null;
    // eslint-disable-next-line no-unused-expressions
    modifiedPNRModel?.products?.forEach((prod, i) => {
      if (prod?.name === 'Vuela Verde') {
        index = i;
        modifiedPNRModel.products[index].tax = ancillary?.currency?.totalTax;
        modifiedPNRModel.products[index].id = '09T';
        modifiedPNRModel.products[index].segment = segment[i];
        modifiedPNRModel.products[index].pax = pax;
      }
    });
    return objects.manage.checkout(modifiedPNRModel);
  } else {
    return objects.manage.checkout(modifiedPNRModel);
  }
}

function trackStepInit(pnrInfo) {
  return objects.manage.stepInitSchema(pnrInfo);
}
function mealPromotionImpression({ currentSegmentCode, currentMealsSelected, indexPassenger, lostSelection, passengers, pnrModel }) {
  let isUpdateAction = false;
  let isSaveAction = false;
  let route = undefined;
  const region = pnrModel.getRegionBySegmentCode(currentSegmentCode);

  const mealMenuForPassengerAndFlight = currentMealsSelected.find(meal =>
    meal.id === passengers[indexPassenger].id
    && meal.mealSegmentCode === currentSegmentCode
  );

  if (mealMenuForPassengerAndFlight !== undefined) {
    isUpdateAction = true;
  } else {
    isSaveAction = true;
  }

  const isLostSelection = (isUpdateAction && lostSelection) || false;

  if (currentSegmentCode) {
    const arrRoute = currentSegmentCode.split('_');
    route = `${ arrRoute[0] }-${ arrRoute[1] }`;
  }
  const dataToTracking = {
    pnrCode: pnrModel.pnrCode,
    route: route,
    promotions: [],
  };

  const copyForID = isSaveAction ? 'Save' : isLostSelection ? 'Not Available' : 'Update';
  dataToTracking.promotions.push({
    id: `mealPreselect - ${ copyForID }`,
    name: `mealPreselect - ${ _getRegionName(region) }`,
    creative: 'NA',
    position: 'MYB',
  });

  return objects.manage.promotion.impression(dataToTracking);
}

function lookUpSuccess({ modifiedPNRModel }) {
  return objects.manage.lookup.success(modifiedPNRModel);
}

function personalizedAcquisition(options) {
  return objects.ecommerce.personalizedAcquisition(options);
}

function purchase({ modifiedPNRModel, ancillaryBuilderInstance, wasPnrHold, cartOnHold, pnrModel }) {
  [modifiedPNRModel.products, modifiedPNRModel.productsCP, modifiedPNRModel.CPflights] = _getProducts(modifiedPNRModel, ancillaryBuilderInstance);
  if (modifiedPNRModel?.products?.some(ancillary => ancillary?.name === 'Vuela Verde')) {
    const ancillary = ancillaryBuilderInstance?.ancillariesModel['09T'];
    const segment = [];
    // eslint-disable-next-line no-unused-expressions
    pnrModel?.legCollection?.map(leg => {
      if (leg?.segmentsCollection?.length > 1) {
        segment.push(getDepartureAirportByLeg(leg?.segmentsCollection) + '-' + getArrivalAirportByLeg(leg?.segmentsCollection));
      } else {
        segment.push(leg?.segmentsCollection.map(segment => segment?.departureAirport + '-' + segment?.arrivalAirport)[0]);
      }
    });
    const pax = pnrModel?.cart?.travelerCollection?.length;
    let index = null;
    // eslint-disable-next-line no-unused-expressions
    modifiedPNRModel?.products?.forEach((prod, i) => {
      if (prod?.name === 'Vuela Verde') {
        index = i;
        modifiedPNRModel.products[index].tax = ancillary?.currency?.totalTax;
        modifiedPNRModel.products[index].id = '09T';
        modifiedPNRModel.products[index].segment = segment[i];
        modifiedPNRModel.products[index].pax = pax;
      }
    });
    return objects.manage.purchase(modifiedPNRModel, wasPnrHold, cartOnHold);
  } else {
    return objects.manage.purchase(modifiedPNRModel, wasPnrHold, cartOnHold);
  }
}

function newPurchase({ 
  ancillariesForPurchaseMetric,
  ancillaryBuilderInstance,
  creditCard,
  isActiveFlowCorporate,
  modifiedPNRModel,
  paymentFormData,
  pnrInfo,
  purchaseOrder,
  userCorporate,
  userProfile,
}) {
  [modifiedPNRModel.products, modifiedPNRModel.productsCP, modifiedPNRModel.CPflights] = _getProducts(modifiedPNRModel, ancillaryBuilderInstance);
  if (modifiedPNRModel?.products?.some(ancillary => ancillary?.name === 'Vuela Verde')) {
    const ancillary = ancillaryBuilderInstance?.ancillariesModel['09T'];
    const segment = [];

    (pnrInfo?.legCollection || []).map(leg => {
      if (leg?.segmentsCollection?.length > 1) {
        segment.push(getDepartureAirportByLeg(leg?.segmentsCollection) + '-' + getArrivalAirportByLeg(leg?.segmentsCollection));
      } else {
        segment.push((leg?.segmentsCollection || []).map(segment => segment?.departureAirport + '-' + segment?.arrivalAirport)[0]);
      }
    });
    const pax = pnrInfo?.cart?.travelerCollection?.length;
    let index = null;

    (modifiedPNRModel?.products || []).forEach((prod, i) => {
      if (prod?.name === 'Vuela Verde') {
        index = i;
        modifiedPNRModel.products[index].tax = ancillary?.currency?.totalTax;
        modifiedPNRModel.products[index].id = '09T';
        modifiedPNRModel.products[index].segment = segment[i];
        modifiedPNRModel.products[index].pax = pax;
      }
    });
  }
  return objects.manage.newPurchase({
    ancillariesForPurchaseMetric,
    creditCard,
    isActiveFlowCorporate,
    modifiedPNRModel,
    paymentFormData,
    pnrInfo,
    purchaseOrder,
    userCorporate,
    userProfile,
  });
}

function receiptPrint(data) {
  return objects.manage.receiptSchema(data);
}

function mealPromotionClick({ closing, currentSegmentCode, pnrModel, promotions }) {
  const region = pnrModel.getRegionBySegmentCode(currentSegmentCode);
  let route = undefined;
  if (currentSegmentCode) {
    const arrRoute = currentSegmentCode.split('_');
    route = `${ arrRoute[0] }-${ arrRoute[1] }`;
  }

  const dataToTracking = {
    pnrCode: pnrModel.pnrCode,
    route: route,
    promotions: [],
  };
  const regionName = _getRegionName(region);

  if (closing) {
    dataToTracking.promotions.push({
      id: 'mealPreselect - Close',
      name: `mealPreselect - ${ regionName }`,
      creative: 'NA',
      position: 'MYB',
    });
  } else {
    promotions.forEach(promo => {
      if (promo.action) {
        const creativeRegionName = regionName === 'Asia' ? promo.menuType : regionName;
        dataToTracking.promotions.push({
          id: `mealPreselect - ${ promo.action }`,
          name: `mealPreselect - ${ regionName }`,
          creative: promo.creative ? `${ promo.creative } - ${ creativeRegionName }` : 'NA',
          position: 'MYB',
        });
      }
    });
  }
  return objects.manage.promotion.click(dataToTracking);
}

function mealGetPromotionClickGrouped(mealsSelected, currentMealsSelected) {
  return mealsSelected.length ? _getActionMeal(mealsSelected, currentMealsSelected) : [];
}

function alreadyOnProducts(product, products) {
  let isProductInArray = null;

  products.forEach((item, index) => {
    if (product?.id === 'UPG') {
      if (item?.segmentCode === product?.segmentCode && item?.id === 'UPG') {
        isProductInArray = index;
      }
    } else {
      if (item?.category === product?.category && item?.id === product?.id) {
        isProductInArray = index;
      }
    }
  });

  return isProductInArray;
}

function _getProducts(modifiedPNRModel, ancillaryBuilderInstance) {
  const {
    cart,
    isOnHold,
    confirmationModel,
  } = modifiedPNRModel;

  const cartConfirmation = get(confirmationModel, 'cartConfirmation', null);
  let products = [];
  const marketingCarrier = get(modifiedPNRModel, 'legCollection[0].segmentsCollection[0].marketingCarrier', undefined);
  const internationalFlight = ancillaryBuilderInstance?.pnrInfo?.globalMarketFlight !== 'DOMESTIC';

  let unPaidAncillaries = cart.getAllUnPaidAncillaries();
  let unPaidSeats = cart.getAllUnPaidSegmentChoice(isOnHold);
  const typeOfPassengers = [
    {
      paxType: 'ADULT',
      price: 0,
      quantity: 0,
    },
    {
      paxType: 'CHILD',
      price: 0,
      quantity: 0,
    },
  ];

  if (cartConfirmation) {
    unPaidAncillaries = cartConfirmation.getAllTicketedAncillaries();
    const unPaidSeatsObj = cartConfirmation.getTicketedSegmentChoice(confirmationModel.getSegmentCodesForAllLegs());

    if (unPaidSeatsObj) {
      unPaidSeats = [];
      Object.keys(unPaidSeatsObj).forEach(travelerId => {
        Object.keys(unPaidSeatsObj[travelerId]).forEach(segmentCode => {
          if (unPaidSeatsObj[travelerId][segmentCode]) {
            unPaidSeats.push(unPaidSeatsObj[travelerId][segmentCode]);
          }
        });
      });
    }
  }

  let productsCP = 0;
  if (unPaidAncillaries) {
    unPaidAncillaries.forEach((ancillary) => {
      const commercialNameBaggage = !internationalFlight ? ancillaryBuilderInstance?.getNewNameBaggage(ancillary.getType()) : ancillaryBuilderInstance?.getNewNameBaggageInternational(ancillary.getType());
      productsCP += ancillary.ancillary.redeemedCP ? 1 : 0;
      ancillary.flightItineraryType = modifiedPNRModel.flightItineraryType;
      ancillary.legCollection = modifiedPNRModel.legCollection;
      ancillary.marketingCarrier = CARRIERS[marketingCarrier];
      const isBaggage = ancillaryBuilderInstance?.isBaggage(ancillary.getType());
      const isInstallment = ancillaryBuilderInstance?.isInstallment(ancillary.getType());
      const ancillaryType = isInstallment ? 'MSI' : ancillary.getType();
      ancillary.ancillary.commercialName = isBaggage ? commercialNameBaggage : ancillaryBuilderInstance?.ancillariesModel?.[ancillaryType]?.nameImpression;
      let product = objects.ecommerce.product.product(ancillary);
      product.segmentCode = product?.id === 'UPG' ? ancillary?.segmentCode : undefined;
      const position = alreadyOnProducts(product, products);

      if (isBaggage && Object.keys(product).length > 0) {
        const newProductBaggge = { ...product };
        const carryOnBag = newProductBaggge?.name === 'Carry On 15 kg / International' || newProductBaggge?.name === 'Carry On 15 kg / Domestic';
        const showNameCheckedBag = !carryOnBag ? 'baggageCheckedBag' : 'baggageCarryonBag';

        const newProductBaggageSchema = {
          name: newProductBaggge.name,
          id: newProductBaggge.id,
          price: newProductBaggge.price,
          brand: newProductBaggge.brand,
          category: newProductBaggge.category,
          [ showNameCheckedBag ]: newProductBaggge.name,
          variant: newProductBaggge.variant,
          quantity: newProductBaggge.quantity,
        };

        product = newProductBaggageSchema;
      }

      if (position !== null) {
        products[position].quantity += 1;
        products[position].variant = products[position].variant.concat(product.variant);
      } else {
        products.push(product);
      }
    });
  }

  let productsSeatCP = 0;
  if (unPaidSeats) {
    unPaidSeats.forEach((seat) => {
      productsSeatCP += seat.redeemedCP ? 1 : 0;
      seat.flightItineraryType = modifiedPNRModel.flightItineraryType;
      seat.legCollection = modifiedPNRModel.legCollection;
      seat.marketingCarrier = CARRIERS[marketingCarrier];
      seat.brand = modifiedPNRModel.getSegmentByCode(seat.segmentCode).operatingCarrier === 'DL' ? 'Delta' : 'Aeromexico';
      products.push(objects.ecommerce.product.product(seat));
    });
  }

  if (cartConfirmation) {
    products.forEach(productItem => {
      //  data purchase Chubb Us por pasajero
      if (productItem?.id === 'SVI') {
        const travelerCollection = cartConfirmation?.travelerCollection;

        const travelersAvailablesChubb = travelerCollection.filter(traveler => {
          const departureDateLastSegment = modifiedPNRModel.getDepartureDateLastSegment();
          const isInsuranceAvailableForTraveler = traveler.isInsuranceAvailableForTraveler(departureDateLastSegment);

          if (isInsuranceAvailableForTraveler) {
            return traveler;
          }
        });

        travelersAvailablesChubb.forEach(traveler => {
          const ancillariesPax = traveler?.ancillaries?.ancillaries;

          if (ancillariesPax.length > 0) {
            const objSvi = ancillariesPax.filter(anc => {
              return anc?.ancillary?.type === 'SVI';
            });

            const sviData = objSvi.length > 0 ? objSvi?.[0]?.ancillary : null;

            typeOfPassengers.forEach(pax => {
              if (pax.paxType === traveler?.paxType) {
                pax.price = sviData ? sviData?.currency?.total : null;
                pax.quantity += 1;
              }
            });
          }
        });

        typeOfPassengers.forEach(passengerType => {
          if (passengerType.quantity !== 0) {
            const minusTitle = passengerType.paxType.slice(1).toLocaleLowerCase();
            const firtsLetter = passengerType.paxType[0];
            const paxType = firtsLetter + minusTitle;

            products.push({
              name: 'Travel Insurance USA',
              id: productItem?.id,
              brand: 'Chubb',
              category: productItem?.category,
              variant: paxType,
              price: passengerType?.price,
              quantity: passengerType?.quantity,
            });
          }
        });
      }
    });
  }

  if (unPaidAncillaries && cartConfirmation === null) {
    products.forEach(productItem => {
      //  data checkout Chubb Us por pasajero
      if (productItem?.id === 'SVI') {
        const travelerCollection = modifiedPNRModel?.cart?.travelerCollection;

        const travelersAvailablesChubb = travelerCollection.filter(traveler => {
          const departureDateLastSegment = modifiedPNRModel.getDepartureDateLastSegment();
          const isInsuranceAvailableForTraveler = traveler.isInsuranceAvailableForTraveler(departureDateLastSegment);

          if (isInsuranceAvailableForTraveler) {
            return traveler;
          }
        });

        travelersAvailablesChubb.forEach(traveler => {
          const ancillariesPax = traveler?.ancillaries?.ancillaries;

          if (ancillariesPax.length > 0) {
            const objSvi = ancillariesPax.filter(anc => {
              return anc?.ancillary?.type === 'SVI';
            });

            const sviData = objSvi.length > 0 ? objSvi?.[0]?.ancillary : null;

            typeOfPassengers.forEach(pax => {
              if (pax.paxType === traveler?.paxType) {
                pax.price = sviData?.currency?.total;
                pax.quantity += 1;
              }
            });
          }
        });

        typeOfPassengers.forEach(passengerType => {
          if (passengerType.quantity !== 0) {
            const minusTitle = passengerType.paxType.slice(1).toLocaleLowerCase();
            const firtsLetter = passengerType.paxType[0];
            const paxType = firtsLetter + minusTitle;

            products.push({
              name: 'Travel Insurance USA',
              id: productItem?.id,
              brand: 'Chubb',
              category: productItem?.category,
              variant: paxType,
              price: passengerType?.price,
              quantity: passengerType?.quantity,
            });
          }
        });
      }
    });
  }

  products = products.filter(product => {
    if (product?.id === 'SVI') {
      if (product?.name !== 'International Travel Insurance' && product?.brand !== 'Aeroméxico') {
        return product;
      }
    } else {
      return product;
    }
  });

  return [products, productsCP, productsSeatCP ? productsSeatCP : undefined];
}

function _getActionMeal(mealsSelected, currentMealsSelected) {
  const selectedDishes = _getArraySegmentPax(mealsSelected);
  const totalCurrent = currentMealsSelected.length;
  let currentDishes = [];
  let arrActionOnDish = [];
  if (totalCurrent) {
    currentDishes = _getArraySegmentPax(currentMealsSelected);
    Object.keys(selectedDishes).forEach(segment => {
      arrActionOnDish[segment] = [];
      Object.keys(selectedDishes[segment]).forEach(pax => {
        if (currentDishes && currentDishes[segment] && currentDishes[segment][pax]) {
          if (currentDishes[segment][pax].mealCode === selectedDishes[segment][pax].mealCode) {
            // Same dish, to do nothing
          } else {
            arrActionOnDish[segment][pax] = {
              action: 'Update', // Action to do
              mealDescription: selectedDishes[segment][pax].mealDescription, // All description of dish
              mealType: selectedDishes[segment][pax].mealType, // For oriental and western meal
            };
          }
        } else if (currentDishes && currentDishes[segment]) {
          if (!currentDishes[segment][pax]) {
            arrActionOnDish[segment][pax] = {
              action: 'Save', // Action to do
              mealDescription: selectedDishes[segment][pax].mealDescription, // All description of dish
              mealType: selectedDishes[segment][pax].mealType, // For oriental and western meal
            };
          }
        }
      });
    });
  } else {
    // First selection of meal
    Object.keys(selectedDishes).forEach(segment => {
      Object.keys(selectedDishes[segment]).forEach(pax => {
        selectedDishes[segment][pax] = {
          action: 'Save', // Action to do
          mealDescription: selectedDishes[segment][pax].mealDescription, // All description of dish
          mealType: selectedDishes[segment][pax].mealType, // For oriental and western meal
        };
      });
    });
    arrActionOnDish = selectedDishes;
  }
  return arrActionOnDish;
}

function _getArraySegmentPax(mealArray) {
  const arrSegmentPax = [];
  mealArray.forEach(meal => {
    arrSegmentPax[meal.mealSegmentCode] = [];
  });
  mealArray.forEach(meal => {
    arrSegmentPax[meal.mealSegmentCode][`${ meal.id }`] = meal;
  });
  return arrSegmentPax;
}

function _getRegionName(route) {
  let regionName = 'NA';

  switch (route) {
    case 'USA':
    case 'NA':
      regionName = 'USA';
      break;

    case 'EUR':
    case 'EU':
      regionName = 'Europa';
      break;

    case 'ASI':
    case 'AS':
      regionName = 'Asia';
      break;

    case 'SA':
    case 'BR':
    case 'GRU':
    case 'SUD':
      regionName = 'Sudamerica';
      break;

    case 'HAV':
    case 'CAM':
    case 'CAR':
      regionName = 'Centroamerica';
      break;

    case 'CAN':
      regionName = 'Canada';
      break;
  }

  return regionName;
}

function trackLogin({ event, actionType, sectionName, loginButton, coBrandedCard, loginType, clubpremierID, touchPoint }) {
  return objects.profile.loginAttempt(event, actionType, sectionName, loginButton, coBrandedCard, loginType, clubpremierID, touchPoint);
}

function trackUserLogin({ event, funnelName, method, risk, subFunnelName }) {
  return objects.profile.userLoginSchema(event, funnelName, method, risk, subFunnelName);
}

function trackUserSignUp({ event, funnelName, subFunnelName, referredAdn }) {
  return objects.profile.userSignUpSchema(event, funnelName, subFunnelName, referredAdn);
}

function trackLoginFail({ event, actionType, loginErrorType, sectionName, loginButton }) {
  return objects.profile.loginFailSchema(event, actionType, loginErrorType, sectionName, loginButton);
}

function errorTracking(errorInfo, subFunnelName = null ) {
  const dataToTracking = {
    type: 'LEVEL 2',
    statusCode: errorInfo.errorData.statusCode || errorInfo.errorData.code,
    code: errorInfo.errorData.code,
    actionable: errorInfo.errorData.actionable,
    actionType: errorInfo.actionType,
    message: errorInfo?.errorData?.errorMsg || errorInfo.errorData.msg,
    extraInfo: errorInfo?.errorData?.errorExtraInfo || errorInfo?.errorData?.extraInfo?.debugging_stuff_here || errorInfo?.errorData?.actionable,
    url: ULR_PATH,
  };

  return objects.manage.webErrorTrackingSchema(dataToTracking, subFunnelName);
}

function webErrorSchemaTracking(errorInfo, subFunnelName) {
  return objects.manage.webErrorTrackingSchema(errorInfo, subFunnelName);
}

function webErrorTracking(actionType, errorInfo) {
  return objects.manage.webErrorSchema(actionType, errorInfo);
}

function errorTrackingRefund(errorInfo) {
  const dataToTracking = {
    type: 'LEVEL 2',
    statusCode: errorInfo.statusCode,
    code: errorInfo.errorData.code,
    actionable: errorInfo.errorData.actionable,
    actionType: errorInfo.actionType,
    message: errorInfo.errorData.msg,
    extraInfo: errorInfo?.errorData?.extraInfo?.debugging_stuff_here || errorInfo?.errorData?.actionable,
    url: ULR_PATH,
  };

  return objects.manage.error(dataToTracking);
}

function errorCPTracking(errorInfo, extraInfo) {
  const dataToTracking = {
    actionable: errorInfo.errorData.actionable,
    code: errorInfo.errorData.code,
    storefront: extraInfo.storefront,
    message: errorInfo.errorData.msg,
    typeofPayment: extraInfo.typeofPayment,
    pnr: extraInfo.pnr,
    numPax: extraInfo.numPax,
    CPmis: extraInfo.CPmis,
    url: ULR_PATH,
  };

  return objects.manage.error(dataToTracking, true);
}

function errorApiServiceTracking(errorInfo, codeError, statusCode, actionType) {
  const codigo = `${ (codeError >= 400 && codeError <= 599) ? '13111301' : codeError }|${ statusCode }|${ actionType }`;
  const dataToTracking = {
    type: 'FATAL',
    statusCode: statusCode === '' ? 503 : parseInt(statusCode, 10),
    code: codigo,
    actionable: errorInfo.errorData.actionable,
    actionType: actionType,
    message: errorInfo.errorData.msg,
    extraInfo: errorInfo?.errorData?.extraInfo?.debugging_stuff_here || errorInfo?.errorData?.actionable,
    url: ULR_PATH,
  };
  return objects.manage.error(dataToTracking);
}

function errorApiServiceTrackingFatal(errorInfo, codeError, statusCode, actionType) {
  const codigo = `${codeError }|${ statusCode }|${ actionType }`;
  const dataToTracking = {
    type: 'FATAL',
    statusCode: statusCode,
    code: codigo,
    actionable: errorInfo?.errorData?.actionable,
    actionType: actionType,
    message: errorInfo?.errorData?.msg,
    extraInfo: errorInfo?.errorData?.extraInfo,
    url: ULR_PATH,
  };
  return objects.manage.error(dataToTracking);
}

function errorChubbPrices(errorInfo, codeError, statusCode, actionType) {
  const codigo = `${ codeError }|${ statusCode }|${ actionType }`;
  const dataToTracking = {
    type: 'WARNING',
    statusCode: statusCode === '' ? 503 : parseInt(statusCode, 10),
    code: codigo,
    actionable: errorInfo.errorData.actionable,
    actionType: actionType,
    message: errorInfo.errorData.msg,
    extraInfo: 'Desconexión',
    url: ULR_PATH,
  };
  return objects.manage.continueChubb(dataToTracking);
}

function errorCPServiceTracking(errorInfo, codeError, statusCode, actionType) {
  const codigo = `${ codeError }|${ statusCode }|${ actionType }`;
  const dataToTracking = {
    type: 'WARNING',
    statusCode: statusCode,
    code: codigo,
    actionable: errorInfo.errorData.actionable,
    actionType: actionType,
    message: errorInfo.errorData.msg,
    extraInfo: errorInfo.errorData.extraInfo,
    url: ULR_PATH,
  };
  return objects.manage.error(dataToTracking);
}

function errorIropsElegibilityTracking(errorInfo, codeError, statusCode, actionType) {
  const codigo = `${ codeError }|${ statusCode }|${ actionType }`;
  const dataToTracking = {
    type: 'WARNING',
    statusCode: statusCode,
    code: codigo,
    actionable: errorInfo.errorData.actionable,
    actionType: actionType,
    message: errorInfo.errorData.msg,
    extraInfo: errorInfo.errorData.extraInfo,
    url: ULR_PATH,
  };
  return objects.manage.error(dataToTracking);
}

function addedFrequentFlyerNumber({ ffProgram, frequentFlyerNumber, status }) {
  const dataToTracking = {
    ffProgram: ffProgram,
    frequentFlyerNumber: frequentFlyerNumber,
    status: status,
  };
  return objects.manage.frequentFlyer(dataToTracking);
}

function errorFormTracking(errorFormName) {
  return objects.manage.formError(errorFormName);
}
function trackLogOut({ event, actionType, sectionName }) {
  return objects.profile.logOutSchema(event, actionType, sectionName);
}

function trackReceiptDownload({ event, funnelName, subFunnelName }) {
  return objects.profile.receiptDownloadSchema(event, funnelName, subFunnelName);
}

function trackStep({ event, userType, clubpremierID, yearProfile, grupoFinal, TierLvl, profGender, CPpoints, travelers, paymentMethods, cobrandCardsNumber, CPaccount, passengerData, vouchersinfo }) {
  return objects.profile.stepSchema(event, userType, clubpremierID, yearProfile, grupoFinal, TierLvl, profGender, CPpoints, travelers, paymentMethods, cobrandCardsNumber, CPaccount, passengerData, vouchersinfo);
}

function trackLoginCobranded({ event, sectionName }) {
  return objects.profile.loginCobrandedSchema(event, sectionName);
}

function trackLoginTarjeta({ event, coBrandedCard, clubpremierID, sectionName }) {
  return objects.profile.loginTarjetaSchema(event, coBrandedCard, clubpremierID, sectionName);
}

function trackWelcomeModalClick(trackingData) {
  return objects.manage.welcomeModal(trackingData);
}

function trackPromotionImpression(trackingData) {
  return objects.manage.promotionImpression(trackingData);
}

function trackPromotionBanner(description, title) {
  return objects.manage.viewPromotionSchema(description, title);
}

function selectPromotionImpression(description, title) {
  return objects.manage.selectPromotionSchema(description, title);
}

function userProfileRegistrationOtp(step, label) {
  return objects.profile.userProfileRegistrationOtpSchema(step, label);
}

function useSavedPaymentMethods(event, actionType, profileField, detailProfile) {
  return objects.profile.useSavedPaymentMethodsSchema(event, actionType, profileField, detailProfile);
}

function validateEMDVoucher(isValid, voucher) {
  return objects.ecommerce.emdVoucherValidate(isValid, voucher);
}

function sendEmail() {
  return objects.manage.sendEmailDispatch();
}

function updateConsentCp({ eventAction, eventLabel }) {
  return objects.profile.updateConsentCpSchema(eventAction, eventLabel);
}

function errorTrackingApi(msgError) {
  // para la metrica error cuando el error es codigo 500601
  const errorInfo = JSON.parse(msgError);
  const logout = safeLocalStorage.getItem('logoutFail');
  const dataToTracking = {
    type: 'LEVEL 2',
    statusCode: errorInfo && errorInfo.status ? errorInfo.status : errorInfo.code == '15111802' ? '401' : '400',
    code: `${ errorInfo?.code }|${ errorInfo?.status || (errorInfo?.code == '15111802' ? '401' : '400') }|${ logout ? 'USER_LOGOUT' : errorInfo?.actionType || 'RETRIEVE_USER_PROFILE_ON_SIGNIN' }`,
    actionable: errorInfo.actionable,
    actionType: logout ? 'USER_LOGOUT' : errorInfo?.actionType || 'RETRIEVE_USER_PROFILE_ON_SIGNIN', // error_id, copyId del code de errores
    message: errorInfo.msg,
    extraInfo: errorInfo.extraInfo,
  };

  safeLocalStorage.removeItem('logoutFail');

  return objects.profile.apiErrorSchema(dataToTracking);
}

function warningServiceTracking(apiWarning) {
  const warningInfo = apiWarning && apiWarning.warnings && apiWarning.warnings[0] ? apiWarning.warnings[0] : null;
  const actionType = apiWarning && apiWarning.actionType ? apiWarning.actionType : null;
  const codeError = warningInfo && warningInfo.code ? warningInfo.code : null;
  const codigo = `${codeError}|${codeError}|${actionType}`;

  const dataToTracking = {
    type: 'WARNING',
    statusCode: codeError,
    code: codigo,
    actionable: warningInfo.actionable,
    actionType: actionType,
    message: warningInfo.msg,
    extraInfo: warningInfo.extraInfo.extra,
    url: ULR_PATH,
  };

  return objects.manage.error(dataToTracking);
}

function registerCPTracking(registerData) {
  const registerCPTracking = {
    clubPremierID: registerData.clubPremierID, // Dynamic Data
    country: registerData.country, // Dynamic Data
    EdadProfile: registerData.EdadProfile, // Dynamic Data
    profGender: registerData.profGender, // Dynamic Data
    storefront: registerData.storefront,
    touchPoint : registerData.touchPoint,
    yearProfile: registerData.yearProfile, // Dynamic Data
  };

  return objects.manage.registerCP(registerCPTracking);
}

function trackCorporatePnrLookup(dataToTracking) {
  return objects.ecommerce.corporatePnrLookup(dataToTracking);
}

function cobrandAffiliate(options) {
  return objects.ecommerce.cobrandAffiliate(options);
}

function trackCorporateSeatMap(dataToTracking) {
  return objects.ecommerce.corporateSeatMap(dataToTracking);
}

function trackCorporatePriority(dataToTracking) {
  return objects.ecommerce.corporatePriority(dataToTracking);
}

function trackB2BC(dataToTracking) {
  return objects?.ecommerce?.B2BCAnalytics(dataToTracking);
}

function trackFareLockPurchase(dataToTracking) {
  return objects.ecommerce.fareLockPurchase(dataToTracking);
}

function trackSeatsSelection(dataToTracking) {
  return objects.ecommerce.seats(dataToTracking);
}

function seatsViewItem(products, pnrModel, user, isActiveFlowCorporate, userCorporate) {
  return objects.ecommerce.seatViewItemSchema(products, pnrModel, user, isActiveFlowCorporate, userCorporate);
}

function trackChangeAcceptSC(dataToTracking) {
  return objects.scheduleChange.changeAcceptedSC(dataToTracking);
}

function trackPromotionClickSC(dataToTracking) {
  return objects.scheduleChange.promotionClickSC(dataToTracking);
}

function trackPromotionImpressionSC(dataToTracking) {
  return objects.scheduleChange.promotionImpressionSC(dataToTracking);
}

function trackuserPropertiesWeb(pnrInfo, user, subFunnelName, storeFront, corporate) {
  return objects?.ecommerce?.userPropertiesWebSchema(pnrInfo, user, subFunnelName, storeFront, corporate);
}

function trackAutoAccept(pnrModel) {
  return objects?.ecommerce?.autoAcceptSchema(pnrModel);
}

function trackStepFlight(pnrInfo, subFunnelName) {
  return objects.manage.stepFlightSchema(pnrInfo, subFunnelName);
}

// metricas upgrade
function trackUpgradeProductImpression({ event, currencyCode, id, name, price, brand, category, variant, position, balance }) {
  return objects.upgrade.productImpression(event, currencyCode, id, name, price, brand, category, variant, position, balance);
}

function trackUpgradeProductClick({ event, currencyCode, id, name, price, brand, category, variant, position, balance }, user) {
  return objects.upgrade.productClick(event, currencyCode, id, name, price, brand, category, variant, position, balance, user);
}

function trackUpgradeMYBPurchase({ event, purchasePlace, paymentForm, storeFront, products, taxes, revenue, balance }) {
  return objects.upgrade.mybPurchase(event, purchasePlace, paymentForm, storeFront, products, taxes, revenue, balance);
}

function registerFailCPTracking(registerData) {
  const registerFailCPTracking = {
    storefront: registerData.storefront, // Dynamic Data
  };

  return objects.manage.registerFailCP(registerFailCPTracking);
}

function promotionSignPopUp(optionMetric) {
  const typeFlight = {
    ROUNDTRIP : 'RT',
    ONEWAY: 'OW',
  };
  const flightType = typeFlight[optionMetric.flightType] || 'MC';
  const flightCategory = REGIONS.REGIONS_OF_FLIGHT[optionMetric.flightCategory] || null;
  let familyFare = null;
  let routes = null;
  if (optionMetric.route.length !== 0) {
    if (flightType !== 'MC') {
      const { departure, arrival } = optionMetric.route[0];
      familyFare = FARES.FARE_FAMILIES_NAMES[optionMetric.familyFare[0]];
      routes = `${departure}-${arrival}`;
    } else {
      familyFare = optionMetric.familyFare.map(fareType => FARES.FARE_FAMILIES_NAMES[fareType] ).join('-');
      routes = optionMetric.route.map(route => `${route.departure}-${route.arrival}`).join(':');
    }
  }
  const { typePromotion, creative } = optionMetric;

  return objects.manage.promotionPopUpSchema({ flightType, flightCategory, familyFare, routes, typePromotion, creative });
}

function trackRecoverPinPassword(type) {
  return objects.profile.recoverPinPasswordSchema(type);
}

function trackUpgradeVoucherRedeem(obj) {
  return objects.profile.upgradeVoucherRedeemSchema(obj);
}

export default {
  addedFrequentFlyerNumber,
  baggageImpression,
  checkout,
  cobrandAffiliate,
  errorApiServiceTracking,
  errorApiServiceTrackingFatal,
  errorChubbPrices,
  errorCPServiceTracking,
  errorCPTracking,
  errorFormTracking,
  errorIropsElegibilityTracking,
  errorTracking,
  errorTrackingApi,
  errorTrackingRefund,
  lookUpSuccess,
  mealGetPromotionClickGrouped,
  mealPromotionClick,
  mealPromotionImpression,
  seatsViewItem,
  sendEmail,
  newPurchase,
  personalizedAcquisition,
  promotionSignPopUp,
  purchase,
  receiptPrint,
  selectPromotionImpression,
  registerCPTracking,
  registerFailCPTracking,
  tierBenefitRedemption,
  trackAutoAccept,
  trackB2BC,
  trackChangeAcceptSC,
  trackCorporatePnrLookup,
  trackCorporatePriority,
  trackCorporateSeatMap,
  trackFareLockPurchase,
  trackLogin,
  trackLoginCobranded,
  trackLoginFail,
  trackLoginTarjeta,
  trackLogOut,
  trackPromotionBanner,
  trackReceiptDownload,
  trackRecoverPinPassword,
  trackPromotionClickSC,
  trackPromotionImpression,
  trackPromotionImpressionSC,
  trackStep,
  trackStepFlight,
  trackSeatsSelection,
  trackStepInit,
  trackUpgradeMYBPurchase,
  trackUpgradeProductClick,
  trackUpgradeProductImpression,
  trackUserSignUp,
  trackWelcomeModalClick,
  trackuserPropertiesWeb,
  updateConsentCp,
  trackUpgradeVoucherRedeem,
  trackUserLogin,
  userProfileRegistrationOtp,
  useSavedPaymentMethods,
  validateEMDVoucher,
  warningServiceTracking,
  webErrorSchemaTracking,
  webErrorTracking,
};
